import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ValhueSection } from "@/components/ValhueSection";
import { ContactSection } from "@/components/ContactSection";

export default function Home() {
  return (
    <main className="bg-[#0A2647]">
      <Navbar />
      <Hero />
      <ValhueSection />
      <ContactSection />
    </main>
  );
}
